export default "__VITE_ASSET__ClCJSpVs__"